<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="10">
          <a-col :md="6" :sm="24">
            <a-form-item label="Query">
              <a-input v-model="queryParam.query" placeholder="Name/Email" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = { query: '' }">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('ADM_EMPLOYEE_ADD')">New</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" :disabled="!$auth('ADM_EMPLOYEE_EDIT')">Edit</a>
          <a-divider type="vertical" />
          <a-popconfirm title="Are you sure delete?" @confirm="onDeleteConfirmed(record)" okText="Yes" cancelText="No">
            <a href="javascript:;" :disabled="!$auth('ADM_EMPLOYEE_DELETE')">Delete</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
  </div>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'
import { toSTablePage } from '@/utils/util'
import EmployeeApi from '@/api/adm/api-employee'

export default {
  name: 'EmployeeList',
  components: {
    AInput,
    STable
  },
  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { query: '' },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: 'Name',
          dataIndex: 'name'
        },
        {
          title: 'Birthday',
          dataIndex: 'birthday',
          customRender: (value) => this.dateFormat(value)
        },
        {
          title: 'Email',
          dataIndex: 'email'
        },
        {
          title: 'Join Date',
          dataIndex: 'joinDate',
          customRender: (value) => this.DateTimeUtil().localString(value)
        },
        {
          title: 'Status',
          dataIndex: 'status',
          // 0 离职 1 在职
          customRender: (value) => value === '0' ? 'left job' : 'serving'
        },
        {
          title: 'Change By',
          dataIndex: 'changeBy',
          customRender: (value) => value ? value.userName : ''
        },
        {
          title: 'Change Time',
          dataIndex: 'writeDate',
          customRender: (value, record) => this.DateTimeUtil().localString(value !== null ? value : record.createDate)
        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return EmployeeApi.query(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      EmployeeApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('User delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    handleOk () {
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
